export const trackEvent = (category, action, name) => {
    if (window._paq && process.env.REACT_APP_ENV === 'production') {
        window._paq.push(['trackEvent', category, action, name]);
    }
};

const STORAGE_KEY = "logbook_event_triggers";

export const fireEventOncePerTour = (tourId, eventKey, callback) => {
    if (!tourId || !eventKey) return;

    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");

    if (!existing[tourId]) existing[tourId] = {};

    if (existing[tourId][eventKey]) return;

    callback();

    existing[tourId][eventKey] = true;

    localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
}

/**
 * Clears stored events for a tour, e.g. after saving.
 */
export const clearTourEvents = (tourId) => {
    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    if (existing[tourId]) {
        delete existing[tourId];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    }
}

